<template>
  <div class="div-conteiner-resumo-perfil">
    <div class="div-centro-resumo-perfil">
      <div
        :class="
          origem === 'TrocaParticipacao'
            ? 'div-left-resumo-perfil-operacional'
            : 'div-left-resumo-perfil'
        "
      >
        <p class="paragrafo-info">
          <span class="infos-usuario">
            <b>{{ nome }}</b> </span
          ><br />
          <span class="infos-usuario" v-if="email">{{ email }}</span
          ><br />
          <span class="infos-usuario-plano">Plano {{ plano }}</span
          ><br />
          <span class="infos-usuario" v-if="isRP && chave">Chave {{ chave }}</span>
        </p>
      </div>
      <div class="div-right-resumo-perfil">
        <!-- Define a imagem de fundo do avatar usando :style -->
        <div
          :style="'background-image: url(' + avatar + ')'"
          class="home__avatar-beneficiarios__photo"
          @click="showModalAvatar()"
        >
          <div v-if="incluirFoto" class="semi-circle">
            <b>Incluir foto</b>
          </div>
        </div>
      </div>
    </div>
    <Modal v-if="isModalVisible" style="padding: 0px; align-items: baseline">
      <template v-slot:body>
        <div class="mdl-card-container div-container">
          <br />
          <p class="textoModal2">Legal! Vamos incluir sua foto.<br /><br /></p>
        </div>

        <!-- Exibição do Cropper dependendo do sistema operacional -->
        <div
          v-if="osType === 'macOS' || osType === 'Windows'"
          style="display: flex; justify-content: center; align-items: center; width: 100%"
        >
          <Cropper title="" filename="avatar.jpg" @upload-foto="cropperSaved"></Cropper>
        </div>
        <div
          v-if="osType === 'iOS' || osType === 'Android'"
          style="display: flex; justify-content: center; align-items: center; width: 100%"
        >
          <CropperMobile
            title=""
            filename="avatar.jpg"
            @upload-foto="cropperSaved"
          ></CropperMobile>
        </div>
        <div class="mf__div-btn">
          <br />
          <button
            class="mf__btn--voltar"
            style="margin-top: 15px 0px"
            @click="modalVoltar()"
          >
            Voltar
          </button>
          <br /><br />
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Modal from "./Modal";
import img_editar from "../../public/imagens/Editar.png";
import maleAdult from "../../public/imagens/icons/avatar-male-adult.png";
import femaleAdult from "../../public/imagens/icons/avatar-female-adult.png";
import maleKid from "../../public/imagens/icons/avatar-male-kid.png";
import femaleKid from "../../public/imagens/icons/avatar-female-kid.png";
import maleYoung from "../../public/imagens/icons/avatar-male-young.png";
import femaleYoung from "../../public/imagens/icons/avatar-female-young.png";
import avatarOperacoes from "../../public/imagens/icons/acessoRapido/rp-cinza-1.png";
import avatarGenerico from "../../public/imagens/silhouette.jpg";
import CropperMobile from "@/components/CropperMobile.vue";
import Cropper from "@/components/Cropper.vue";

export default {
  components: {
    Modal,
    CropperMobile,
    Cropper,
  },
  props: ["resumo", "origem"],
  computed: {
    ...mapGetters({
      participante: "participante",
      cpf: "cpf",
      uid: "uid",
      settingsDadosEntidade: "settingsDadosEntidade",
      isRP: "isRP",
    }),
  },
  data() {
    return {
      isModalVisible: false, // Controla a visibilidade do modal
      signedInUserAvatar: "",
      img_editar: img_editar,
      nome: "",
      avatar: "",
      email: "",
      segmento: "",
      segmentoDesc: "",
      resumoPerfil: "",
      liberaUpload: false,
      incluirFoto: false,
      chave: false,
      plano: false,
      osType: false,
    };
  },
  mounted() {
    this.detectOS();
  },
  created() {
    try {
      this.resumoPerfil = this.resumo;
      this.chave = this.resumoPerfil.chave;
      this.plano = this.resumoPerfil.plano;
      this.nome = this.resumoPerfil.nome;
      this.segmento = this.resumoPerfil.segmento;
      this.chave = this.resumoPerfil.chave;
      this.segmentoDesc = this.segmento ? `Segmento ${this.segmento}` : "";
      this.email = this.resumoPerfil.email;

      // Definindo o avatar conforme as opções
      if (this.resumoPerfil.avatar === "maleAdult") {
        this.avatar = maleAdult;
      } else if (this.resumoPerfil.avatar === "femaleAdult") {
        this.avatar = femaleAdult;
      } else if (this.resumoPerfil.avatar === "maleKid") {
        this.avatar = maleKid;
      } else if (this.resumoPerfil.avatar === "femaleKid") {
        this.avatar = femaleKid;
      } else if (this.resumoPerfil.avatar === "maleYoung") {
        this.avatar = maleYoung;
      } else if (this.resumoPerfil.avatar === "femaleYoung") {
        this.avatar = femaleYoung;
      } else if (this.resumoPerfil.avatar === "avatarOperacoes") {
        this.avatar = avatarOperacoes;
      } else if (this.resumoPerfil.avatar === "avatarGenerico") {
        this.avatar = avatarGenerico;
      } else {
        this.avatar = this.resumoPerfil.avatar;
      }

      this.incluirFoto = this.resumo.incluirFoto && !this.isRP && !this.avatar;
      this.liberaUpload = this.origem !== "TrocaParticipacao" && !this.isRP;
    } catch (e) {
      this.$router.push("/");
    }
  },
  methods: {
    detectOS() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (/windows phone/i.test(userAgent)) {
        this.osType = "Windows Phone";
      } else if (/windows/i.test(userAgent)) {
        this.osType = "Windows";
      } else if (/android/i.test(userAgent)) {
        this.osType = "Android";
      } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        this.osType = "iOS";
      } else if (/mac/i.test(userAgent)) {
        this.osType = "macOS";
      } else {
        this.osType = "Outro sistema operacional";
      }
    },
    addSizeToGoogleProfilePic(url) {
      if (url && url !== "") {
        if (url.indexOf("googleusercontent.com") !== -1 && url.indexOf("?") === -1) {
          return url + "?sz=150";
        }
      }
      return url;
    },
    // Agora o cropper só atualiza a variável `avatar`, sem mexer no DOM diretamente.
    cropperSaved(cropData) {
      this.avatar = cropData;
      console.log("avatar", this.avatar);

      if (this.avatar) {
        this.incluirFoto = false;
      }
    },

    showModalAvatar() {
      this.isModalVisible = true; // Exibe o modal
    },
    modalVoltar() {
      this.isModalVisible = false; // Fecha o modal
    },
  },
};
</script>

<style scoped>
.div-centro-resumo-perfil {
  display: flex;
  justify-content: center;
}
.paragrafo-info {
  margin-bottom: 1px;
}
.div-conteiner-resumo-perfil {
  width: 100%;
  display: flex;
  justify-content: center;
  min-width: 300px;
}

.div-left-resumo-perfil {
  float: left;
  text-align: right;
  margin-right: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.div-left-resumo-perfil-operacional {
  float: left;
  width: 200px;
  text-align: right;
  margin-right: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.div-right-resumo-perfil {
  float: right;
  /* width: 35%; */
  cursor: pointer;
}

.home__avatar-beneficiarios__photo {
  width: 95px;
  height: 95px;
  background-size: cover; /* Atualizado para 'cover' */
  background-position: center;
  border-radius: 50%;
  position: relative;
  text-align: center;
}

.infos-usuario-plano {
  margin-top: -11px;
}

.semi-circle {
  height: 27px;
  border-bottom-left-radius: 118% 290%;
  border-bottom-right-radius: 110% 290%;
  position: absolute;
  top: 75%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(102, 102, 102, 0.6);
  color: white;
  width: 88%;
  font-size: 12px;
  line-height: 13px;
  margin-top: 2px;
  padding-top: 3px;
}

@media screen and (max-width: 375px) {
  .infos-usuario,
  .infos-usuario-plano {
    font-size: 10px !important;
    line-height: 12px;
  }
  .paragrafo-info {
    line-height: 15px;
  }
  .home__avatar-beneficiarios__photo {
    width: 65px;
    height: 65px;
  }
}
@media (min-width: 376px) and (max-width: 475px) {
  .infos-usuario,
  .infos-usuario-plano {
    font-size: 12px !important;
    line-height: 14px;
  }
  .paragrafo-info {
    line-height: 17px;
  }
  .home__avatar-beneficiarios__photo {
    width: 80px;
    height: 80px;
  }
}
</style>
